module.exports = __webpack_public_path__ + "static/media/bank_logo.f3a2bff4.svg";